import { Main } from 'Main';
import { Provider } from 'react-redux';
import store from 'core/store';
import { MsalProvider } from '@azure/msal-react';
import ErrorBoundary from 'core/ErrorBoundary';
import { QueryClientProvider } from 'react-query';
import { queryClient } from 'api/client';
import EmotionTheme from 'core/Theming/EmotionTheme';
import { IdleTimerWrapper } from 'core/IdleTimer';
import { MainContainer } from 'components/Layout';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import ScrollContextProvider from 'core/ScrollContext';
import ScrollToTop from 'core/ScrollToTop';
import './App.css';
import { PageContextProvider } from 'core/PageData';
import { reactPlugin } from 'core/logger/ApplicationInsightsService';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { msalInstance } from 'core/auth/userService';

const App = () => {
  return (
    <EmotionTheme>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <MsalProvider instance={msalInstance}>
            <IdleTimerWrapper>
              <AppInsightsContext.Provider value={reactPlugin}>
                <MainContainer>
                  <ErrorBoundary>
                    <ToastContainer />
                    <ScrollToTop />
                    <ScrollContextProvider>
                      <PageContextProvider>
                        <Main />
                      </PageContextProvider>
                    </ScrollContextProvider>
                  </ErrorBoundary>
                </MainContainer>
              </AppInsightsContext.Provider>
            </IdleTimerWrapper>
          </MsalProvider>
        </Provider>
      </QueryClientProvider>
    </EmotionTheme>
  );
};

export default App;
